/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfPrizeListedAdminDto } from '../models/Pagination1OfPrizeListedAdminDto';
import type { PostPrizeAdminRequest } from '../models/PostPrizeAdminRequest';
import type { PrizeAdminDto } from '../models/PrizeAdminDto';
import type { PrizeType } from '../models/PrizeType';
import type { PutPrizeAdminRequest } from '../models/PutPrizeAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PrizesService {
    /**
     * **Required Policy:** `ViewPrizes`
     * @returns Pagination1OfPrizeListedAdminDto OK
     * @throws ApiError
     */
    public static getPrizesAdmin({
        searchWord,
        type,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        type?: PrizeType,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfPrizeListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/prizes',
            query: {
                'searchWord': searchWord,
                'type': type,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePrizes`
     * @returns PrizeAdminDto Created
     * @throws ApiError
     */
    public static createPrizeAdmin({
        requestBody,
    }: {
        requestBody?: PostPrizeAdminRequest,
    }): CancelablePromise<PrizeAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/prizes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewPrizeDetails`
     * @returns PrizeAdminDto OK
     * @throws ApiError
     */
    public static getPrizeByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<PrizeAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/prizes/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManagePrizes`
     * @returns PrizeAdminDto OK
     * @throws ApiError
     */
    public static updatePrizeAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutPrizeAdminRequest,
    }): CancelablePromise<PrizeAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/prizes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeletePrizes`
     * @returns void
     * @throws ApiError
     */
    public static deletePrizeAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/prizes/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
